import PipelineCreatePage from '../../../components/admin/pipeline/PipelineCreatePage'
export default function PipelineCreate() { return <PipelineCreatePage /> }
